import CmtManagement from "../components/admin/comentMng/CmtManagement";

const CommentMng = () => {
  return (
    <div className="comment-page">
      <CmtManagement />
    </div>
  );
};
export default CommentMng;
